import { normalizeSubscriptionPaymentMethod } from './index';

export const mapJusbillSubscription = (data) => {
  const { subscription } = data;
  const amountInCents = subscription.plan?.amount ?? null;
  const amount = amountInCents != null ? amountInCents / 100 : null;

  return {
    client_id: data.client_id,
    external_id: null,
    plan_details: {
      name: subscription.plan?.name ?? null,
      gateway_id: subscription.plan?.id,
      amount,
      periodicity: subscription.plan?.days ?? null,
    },
    info: {
      status: subscription.status,
      provider: subscription.provider,
      subscription_provider: 'jusbill',
      plan: subscription.plan?.name ?? null,
      charged_amount: null,
      plan_amount: amount,
      payment_method: normalizeSubscriptionPaymentMethod(
        subscription.payment_method,
      ),
      current_period_start: subscription.current_period_start,
      current_period_end: subscription.current_period_end,
      latest_update: subscription.date_updated,
      subscription_id: subscription.id,
      card_brand: subscription.card?.brand,
      card_last_digits: subscription.card?.last_digits,
      reason: subscription.reason,
      tickets: subscription.tickets ?? [],
    },
  };
};
